import { Button, View } from "@/components/ui";
import { Divider } from "@/components/shared/divider";
import { ReferralHistorySkeleton } from "./referral-history-skeleton";
import { ReferralHistoryEmpty } from "./referral-history-empty";
import { ReferralHistoryItem } from "./referral-history-item";
import { useRoute } from "@/components/shared/router";
import { useClientReferralByFiltersQuery } from "@/gqlhooks/client/useClientReferralByFiltersQuery";
import { AccountReferralHistoryProps } from "./types";
import { isLastItem } from "@/lib/utils";

export const AccountReferralHistory = ({
  filter = {},
}: AccountReferralHistoryProps) => {
  const { push } = useRoute();
  const { status: statusFiltered, limit, ...rest } = filter;
  const status = statusFiltered === "ALL" ? undefined : statusFiltered;

  const { referralHistoryItems, loading, count } =
    useClientReferralByFiltersQuery({
      status: status ? [status] : undefined,
      limit,
      ...rest,
    });

  const handleViewAll = () => {
    push({ pageKey: "accountMyReferralHistory" });
  };

  const shouldShowViewAll = () => {
    return limit !== null && count > referralHistoryItems.length;
  };

  return (
    <>
      {loading ? (
        <ReferralHistorySkeleton />
      ) : referralHistoryItems.length > 0 ? (
        referralHistoryItems?.map((item, index) => (
          <View key={item.id}>
            <ReferralHistoryItem item={item} />
            {!isLastItem(index, referralHistoryItems.length) && <Divider />}
            {isLastItem(index, referralHistoryItems.length) &&
              shouldShowViewAll() && (
                <View className="flex flex-col items-center py-6">
                  <Button
                    variant="secondary"
                    color="CTA2"
                    size={"md"}
                    rounded="full"
                    onClick={handleViewAll}
                  >
                    View All
                  </Button>
                </View>
              )}
          </View>
        ))
      ) : (
        <ReferralHistoryEmpty />
      )}
    </>
  );
};
